import api from '../api'
import { MessageBox } from 'mint-ui'
import router from '../router'
import {
  USER_SIGNIN,
  USER_SIGNOUT
} from './type'

export const UserLogin = ({ commit }, data) => {
  api.localLogin(data).then(res => {
    if (res.data.result.status === '1') {
      commit(USER_SIGNIN, res.data.result)
      router.push('/home')
    } else {
      MessageBox.close()
      MessageBox('提示', res.data.result.info)
    }
  }).catch(err => {
    console.log(err)
    MessageBox('提示', '网络异常！请稍后在再试')
  })
}

export const UserLogOut = ({ commit }, data) => {
  MessageBox.confirm('确定要退出登录吗?').then(action => {
    commit(USER_SIGNOUT)
    router.replace('/login')
  }).catch(() => {})
}



// WEBPACK FOOTER //
// ./src/store/actions.js